// extracted by mini-css-extract-plugin
export default {"div":"Privacy_div__iSIL2"};